<template>
	<div id="homePage">
		<wc-home :args="charData" v-on:getSelected='reciveParams($event)' ref="home"></wc-home>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	export default{
		name:'Home',
		data(){
			return {
				charData:{
					pointName: localStorage.getItem("point"),
					list:[
						{value:0, name:'最新工单'},
						{value:0,name:'处理中'},
						{value:0,name:'已解决'}		
					],
					total:'获取中'
				}
			}
		},
		methods:{
			reciveParams(msg){
				this.selected=msg;
			},
			calculateHeight(){
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = 51;
				//设置内容区的高度
				var minePage = document.getElementById("homePage");
				minePage.style.height = bodyHei-tabbarHei+"px";
			},
			getWorkOrder(){
				_api('_order','.code',{params:{mark:'workSheetNum'}},res=>{
					let orderMap={0:'latestWorkSheet',1:'processinogWorkSheet',2:'resovledWorkSheet'};
					this.charData.list.forEach((item,index)=>{
						item.value=res.data[orderMap[index]]
					})
					this.charData.total=res.data.orderTotals;
					this.$refs.home.drawPie(this.charData);
					
				},err=>{
					
				})
			}
		},
		mounted() {
			this.calculateHeight();
			this.getWorkOrder();
			console.log(this.$route.query.pointName);
		}
		
	}
</script>

<style scoped="scoped">
	#homePage{
		overflow-y: auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/home/Home.vue